import { Card, CardBody, Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { Btn, H1 } from "../../AbstractElements";
import { URL_API } from "../../utils/helper/helpers";
import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { ActualFileUpload, DropFileUploadText, DropFilesHereOrClickToUpload } from '../../utils/Constant';
import { Dropzone, FileMosaic, ExtFile } from "@dropzone-ui/react";
import { H6 } from '../../AbstractElements';
import SweetAlert from 'sweetalert2';
import useNumBons from "./apiBon";
import { Typeahead } from 'react-bootstrap-typeahead'

// type Fours = { [key: string]: any }
type Option = {
    id: number;
    num: string;
    type: string;
};

const NouveauBonDiamond = ({ id_fournisseur, type }: { id_fournisseur: number, type: string }) => {

    const [selectedFournisseur, setSelectedFournisseur] = useState<string | null>(null);
    const [refresh, setRefresh] = useState(false);
    const navigate = useNavigate();
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false); // Gère l'état d'envoi
    const fournis = useNumBons(refresh) || []
    const Token = JSON.parse(localStorage.getItem("login")!);

    const updateFiles = (incomingFiles: ExtFile[]) => {
        setData((prevState) => ({
            ...prevState,
            file: incomingFiles,
            recu: incomingFiles[0]?.file || null,
        }));
    };
    const removeFile = (id: string | number | undefined) => {
        setData((prevState) => ({
            ...prevState,
            file: data.file.filter((x: ExtFile) => x.id !== id),
            recu: null
        }));
    };

    const [data, setData] = useState({
        destination: '',
        immatriculation: '',
        quantite_tonne: 0,
        chauffeur: '',
        client: '',
        date_bons: '',
        num_permis: '',
        telephone: '',
        selectType: '',
        idNumBons: null as number | null,
        recu: null as File | null,
        file: [] as ExtFile[],
        id: null
    });
    const [erreur, setErreur] = useState({
        destination: '',
        immatriculation: '',
        quantite_tonne: '',
        chauffeur: '',
        client: '',
        date_bons: '',
        num_permis: '',
        telephone: '',
        idNumBons: null,
        recu: [] as ExtFile[],
        id: null
    });



    const changeHandler = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setData((prevState) => ({
            ...prevState,
            [name]: value
        }));
    };

    useEffect(() => {
        if (data.idNumBons) {
            const filtered = fournis.find(item => item.id === (typeof data.idNumBons === 'string' ? parseInt(data.idNumBons) : data.idNumBons));
            if (filtered) {
                setSelectedFournisseur(filtered.type);
            }
        }
        if (data.quantite_tonne) {
            setData((prevState) => ({
                ...prevState,
                quantite_sac: data.quantite_tonne * 20
            }));
        }
        setData((prevState) => ({
            ...prevState,
            selectType: type
        }));
    }, [data.idNumBons, fournis, data.quantite_tonne, data.selectType]);

    const handleSubmitData = (e: React.FormEvent) => {
        e.preventDefault();

        SweetAlert.fire({
            title: 'Informations',
            text: " Les données doivent être envoyé et ne peuvent pas être modifiées ou supprimées !",
            icon: 'info',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Oui, Envoyer'
        }).then((result) => {
            if (result.isConfirmed) {
                setIsSubmitting(true);
                axios.post(`${URL_API}/bon/create`, { ...data }, {
                    headers: {
                        Authorization: `Bearer ${Token}`,
                        'Content-Type': 'multipart/form-data',
                    }
                }).then(response => {

                    if (response.data.success && response.status == 201) {
                        const msg = "Bon de commande ajouté avec succès !!";
                        toast.success(msg);
                        clearDataForm();
                        navigate(`/show-bon-de-commande/${response.data.numBons}`)

                    }
                }).catch(error => {

                    if (error.response && error.response.status === 422) {
                        toast.info("Oups !! Erreur de validation des données");
                        const newErrors = error.response.data.errors;
                        setErreur(prevErrors => ({
                            ...prevErrors,
                            ...newErrors,
                        }));
                    }
                    if (error.response.status === 404) {
                        toast.info(error.response.data.message)
                    }
                    if (error.response.status === 500) {
                        toast.info(error.response.data.message)
                    }
                })
                setIsSubmitting(false);
            }

        });

    }

    const clearDataForm = () => {
        setData({
            destination: '',
            immatriculation: '',
            quantite_tonne: 1,
            client: '',
            chauffeur: '',
            num_permis: '',
            telephone: '',
            date_bons: '',
            selectType: '',
            idNumBons: null,
            recu: null as File | null,
            file: [] as ExtFile[],
            id: null
        });
        setErreur({
            destination: '',
            immatriculation: '',
            quantite_tonne: '',
            client: '',
            chauffeur: '',
            date_bons: '',
            num_permis: '',
            telephone: '',
            idNumBons: null,
            recu: [] as ExtFile[],
            id: null
        });
    }

    return (
        // <div className='page-body'>
        //     <Breadcrumbs mainTitle="Nouveau Bon de Commande" parent="Gestions" />
        //     <Container fluid>
        <Card>
            <CardBody>
                <Form onSubmit={handleSubmitData}>

                    <H1 className="mb-2 text-capitalize text-center fw-bold">
                        {type == 'diamond' ? 'DIAMOND KAGBELEN' : 'DIAMOND SOUGUETA'}
                    </H1>

                    <div className="product-info">
                        <div className="product-group">
                            <Row>
                                <Col sm="6" className="mb-3">
                                    <Label>Numéro Bons</Label>
                                    <Typeahead
                                        id="typeahead-example"
                                        options={fournis.filter(option => option.infos_type === 'Personnel' && (option.four_type === 'diamond' || option.four_type === 'diamond_sougueta'))}
                                        labelKey="num"
                                        placeholder="Selectionner un numéro de bon..."
                                        onChange={(selected) => {
                                            if (selected.length > 0) {
                                                const selectedItem = selected[0] as Option;
                                                setData((prevState) => ({
                                                    ...prevState,
                                                    idNumBons: selectedItem.id,
                                                }));
                                            }
                                        }}
                                    />
                                    {erreur.idNumBons && (
                                        <span className="text-danger">{erreur.idNumBons}</span>
                                    )}
                                </Col>

                                <Col sm="6">
                                    <FormGroup>
                                        <Label>Nom Chauffeur</Label>
                                        <Input
                                            placeholder="Nom Chauffeur"
                                            name="chauffeur"
                                            value={data.chauffeur}
                                            onChange={changeHandler}
                                            type="text"
                                        />
                                        {erreur.chauffeur && (
                                            <span className="text-danger">{erreur.chauffeur}</span>
                                        )}
                                    </FormGroup>
                                </Col>
                                <Col sm="6">
                                    <FormGroup>
                                        <Label>Immatriculation</Label>
                                        <Input
                                            placeholder="Entrer l'immatriculation"
                                            name="immatriculation"
                                            value={data.immatriculation}
                                            onChange={changeHandler}
                                            type="text"
                                        />
                                        {erreur.immatriculation && (
                                            <span className="text-danger">{erreur.immatriculation}</span>
                                        )}
                                    </FormGroup>
                                </Col>

                                <Col sm="6">
                                    <FormGroup>
                                        <Label>Téléphone</Label>
                                        <Input
                                            placeholder="Nom Téléphone"
                                            name="telephone"
                                            value={data.telephone}
                                            onChange={changeHandler}
                                            type="number"
                                        />
                                        {erreur.telephone && (
                                            <span className="text-danger">{erreur.telephone}</span>
                                        )}
                                    </FormGroup>
                                </Col>

                                <Col sm="6">
                                    <FormGroup>
                                        <Label>Destination</Label>
                                        <Input
                                            placeholder="Entrer la destination"
                                            name="destination"
                                            value={data.destination}
                                            onChange={changeHandler}
                                            type="text"
                                        />
                                        {erreur.destination && (
                                            <span className="text-danger">{erreur.destination}</span>
                                        )}
                                    </FormGroup>
                                </Col>
                                <Col sm="6">
                                    <FormGroup>
                                        <Label>Quantité Tonne</Label>
                                        <Input
                                            placeholder="Entrer la quantité en tonne"
                                            name="quantite_tonne"
                                            value={data.quantite_tonne}
                                            onChange={changeHandler}
                                            type="number"
                                        />
                                        {erreur.quantite_tonne && (
                                            <span className="text-danger">{erreur.quantite_tonne}</span>
                                        )}
                                    </FormGroup>
                                </Col>
                                <Col sm="6">
                                    <FormGroup>
                                        <Label>Date d'émission</Label>
                                        <Input
                                            placeholder="Entrer le quantité sac"
                                            name="date_bons"
                                            value={data.date_bons}
                                            onChange={changeHandler}
                                            type="date"
                                        />
                                        {erreur.date_bons && (
                                            <span className="text-danger">{erreur.date_bons}</span>
                                        )}
                                    </FormGroup>
                                </Col>
                                {/* <Col sm="6">
                                    <FormGroup>
                                        <Label>Nom Client</Label>
                                        <Input
                                            placeholder="Nom Client"
                                            name="client"
                                            value={data.client}
                                            onChange={changeHandler}
                                            type="text"
                                        />
                                        {erreur.client && (
                                            <span className="text-danger">{erreur.client}</span>
                                        )}
                                    </FormGroup>
                                </Col> */}

                                <Col sm="6">
                                    <FormGroup>
                                        <Label>Numéro Permis</Label>
                                        <Input
                                            placeholder={selectedFournisseur === 'diamond' ? "Entrer le numéro de permit" : "Entrer le numéro de bon d'evenement"}
                                            name="num_permis"
                                            value={data.num_permis}
                                            onChange={changeHandler}
                                            type="text"
                                        />
                                        {erreur.num_permis && (
                                            <span className="text-danger">{erreur.num_permis}</span>
                                        )}
                                    </FormGroup>
                                </Col>

                            </Row>
                            <Row>
                                <Col>
                                    <FormGroup>
                                        <Label check>Importer le justificatif</Label>
                                        <Dropzone onChange={updateFiles} value={data.file} maxFiles={1} header={false} footer={false} minHeight="80px" label="Drag'n drop files here or click to Browse">
                                            {data.file.map((file: ExtFile) => (
                                                <FileMosaic key={file.id} {...file} onDelete={removeFile} info={true} />
                                            ))}
                                            {data.file.length === 0 && (
                                                <div className="dz-message needsclick p-5">
                                                    <i className="icon-cloud-up font-primary"></i>
                                                    <H6>{DropFilesHereOrClickToUpload}</H6>
                                                    <span className="note needsclick">
                                                        {DropFileUploadText}<strong>not</strong>{ActualFileUpload}
                                                    </span>
                                                </div>
                                            )}
                                        </Dropzone>
                                    </FormGroup>
                                </Col>
                            </Row>
                        </div>
                    </div>
                    <div className="text-end">
                        <Btn color="info" type="submit" disabled={isSubmitting}>{ isSubmitting ? 'En Cours...' : 'Envoyer'}</Btn>
                        <Btn className="btn btn-danger ms-3" onClick={() => clearDataForm()}>Annuler</Btn>
                    </div>
                </Form>
            </CardBody>

        </Card>

        //     </Container>
        // </div>
    )
}

export default NouveauBonDiamond